<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Salary Packaging Provider - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="Provider">Provider</label>
                <input type="text" 
                class="form-control" 
                id="Provider" 
                placeholder="Provider"
                v-model="name">
                <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </div>
            <div class="form-group">
              <label for="fee">Fee</label>
              <input type="number" 
              class="form-control" 
              id="fee" 
              placeholder="Fee"
              v-model="fee">
              <div class="invalid-feedback" v-if="errors.fee">{{ errors.fee[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as salaryPackagingProviderService from '../../services/salaryPackagingProvider.service';
    export default {
        name:"ModalSalaryPackagingProviderNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                name:''
            }
        },
        methods:{
            ...mapActions(['fetchSalaryPackagingProviderAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('name',this.name);
                formData.append('fee',this.fee);
            try{
                await salaryPackagingProviderService.add(formData);
                this.hideModal();
                this.fetchSalaryPackagingProviderAll();

                messageService.fnSweetAlertSuccessToast('Salary packaging provider - new', 'added successfully');

                this.name = '';
                this.fee = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Salary packaging provider - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Salary packaging provider - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>